import React from "react";
import { CommonModule, UCAModule } from "uca-react-containers-library";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import CommunicationPrefV3Component from "./components/communication-preference-v3";
import LoyaltyPartnersV4Component from "./components/loyalty-partners-v4";
import AddressPrefComponent from "./components/address-preference";
import AccountSettingsComponent from "./components/account-settings";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import WebViewRoute from "./WebViewRoute";
import PaymentMethodsComponent from "./components/payment";
import UnSubscribeInterstitialComponent from "./components/unsubscribe-interstitial";
import StudentsComponent from "./components/students";
import StudentsWebViewComponent from "./components/students-webview";
import DiscoutProgramsComponent from "./components/discount-programs";
import AccountDashboardComponent from "./components/account-dashboard";
import DiscountProgramsWebViewComponent from "./components/discount-programs-webview";
import TaxExemptionComponent from "./components/tax-exemption";
import RewardsComponentV2 from "./components/rewards-v2";
import FamilyMembersComponent from "./components/family-members";
import ForgotPasswordComponent from "./components/forgot-password";
import ResetPasswordConfirmationComponent from "./components/reset-password-confirmation";
import CheckTextMessageComponent from "./components/check-text-message";
import ResetPasswordComponent from "./components/reset-password";
import AccountSecurityComponent from "./components/account-security";
import ReferProgramComponent from "./components/refer-program";
import DietaryPrefComponent from "./components/dietary-preference";

function App() {
  const { appData } = CommonModule.useApp();
  const appTheme = `theme-${appData.theme}`;
  const location = window.location.pathname;
  const checkLocation = location.includes('/customer-account/forgot-password') 
    || location.includes('/customer-account/reset-password-confirmation')
    || location.includes('/customer-account/reset-password')
    || location.includes('/customer-account/check-text-message');

  if (location.includes('/account-reset')) {
    return (
        <Router basename='account-reset'>
          <UCAModule.UnauthenticatedHeader />
          <div className={appTheme}>
            <div className="container-fluid">
              <div className="row">
              <Switch>
                  <PublicRoute exact path={['/forgot-password', '/forgot-password.html']}
                    title={`Forgot Password`}
                    banner={appData.banner}
                    component={ForgotPasswordComponent} />
                  <PublicRoute exact path={['/reset-password-confirmation', '/reset-password-confirmation.html']}
                    title={`Reset Password Confirmation`}
                    banner={appData.banner}
                    component={ResetPasswordConfirmationComponent} />  
                  <PublicRoute exact path={['/check-text-message', '/check-text-message.html']}
                    title={`Check Text Message`}
                    banner={appData.banner}
                    component={CheckTextMessageComponent} />
                  <PublicRoute exact path={['/reset-password', '/reset-password.html']}
                    title={`Reset Password`}
                    banner={appData.banner}
                    component={ResetPasswordComponent} />    
                </Switch>
              </div>
            </div>
          </div>
        </Router>
    );
  }
  else if (checkLocation) {
    return (
        <Router basename='customer-account'>
          <UCAModule.UnauthenticatedHeader />
          <div className={appTheme}>
            <div className="container-fluid">
              <div className="row">
                <Switch>
                  <PublicRoute exact path={['/forgot-password', '/forgot-password.html']}
                    title={`Forgot Password`}
                    banner={appData.banner}
                    component={ForgotPasswordComponent} />
                  <PublicRoute exact path={['/reset-password-confirmation', '/reset-password-confirmation.html']}
                    title={`Reset Password Confirmation`}
                    banner={appData.banner}
                    component={ResetPasswordConfirmationComponent} />  
                  <PublicRoute exact path={['/check-text-message', '/check-text-message.html']}
                    title={`Check Text Message`}
                    banner={appData.banner}
                    component={CheckTextMessageComponent} />
                  <PublicRoute exact path={['/reset-password', '/reset-password.html']}
                    title={`Reset Password`}
                    banner={appData.banner}
                    component={ResetPasswordComponent} />    
                </Switch>
              </div>
            </div>
          </div>
        </Router>
    );
  }
  else {
    return (
      <Router basename='customer-account'>
        <div className={appTheme}>
          <div className="container-fluid">
            <div className="row">
              <Switch>
                <PrivateRoute exact path={['/communication-preference', '/communication-preference.html']}
                  title={`Communication Preference`}
                  banner={appData.banner}
                  component={CommunicationPrefV3Component} />                  
                <PrivateRoute exact path={['/dietary-preferences', '/dietary-preferences.html']}
                  title={`Dietary Preferences`}
                  banner={appData.banner}
                  component={DietaryPrefComponent} />                  
                <PrivateRoute exact path={['/loyalty-partners', '/loyalty-partners.html']}
                  title={`Loyalty Partners`}
                  banner={appData.banner}
                  component={LoyaltyPartnersV4Component} />
                <PrivateRoute exact path={['/rewards', '/rewards.html']}
                  title={`Rewards`}
                  banner={appData.banner}
                  component={RewardsComponentV2} />
                <PrivateRoute exact path={['/fulfillment-preferences', '/fulfillment-preferences.html']}
                  title={`Address Preferences`}
                  banner={appData.banner}
                  component={AddressPrefComponent} />
                <PrivateRoute path={['/account-settings', '/account-settings.html']}
                  title={`Account Settings`}
                  banner={appData.banner}
                  component={AccountSettingsComponent} />
                <Route exact path={['/unsubscribe', '/unsubscribe.html']} component={UnSubscribeInterstitialComponent} />
                <PrivateRoute exact path={['/payment', '/payment.html']}
                  title={`Payment Methods`}
                  banner={appData.banner}
                  component={PaymentMethodsComponent} />
                <PrivateRoute exact path={['/family-members', '/family-members.html']}
                  title={`Family Members`}
                  banner={appData.banner}
                  component={FamilyMembersComponent} />
                <WebViewRoute exact path={['/students/view']}
                  title={`Student Discount`}
                  banner={appData.banner}
                  component={StudentsWebViewComponent} />
                <PrivateRoute exact path={['/students', '/students.html']}
                  title={`Student Discount`}
                  banner={appData.banner}
                  component={StudentsComponent} />
                <PrivateRoute exact path={['/discount-programs', '/discount-programs.html']}
                  title={`Discount Programs`}
                  banner={appData.banner}
                  component={DiscoutProgramsComponent} />
                <PrivateRoute exact path={['/discount-programs/:tribeName']}
                  title={`Discount Programs`}
                  banner={appData.banner}
                  component={DiscoutProgramsComponent} />
                <PrivateRoute exact path={['/account-dashboard', '/account-dashboard.html']}
                  title={`Account Dashboard`}
                  banner={appData.banner}
                  component={AccountDashboardComponent} />
                <WebViewRoute exact path={['/view/discount-programs', '/view/discount-programs.html']}
                  title={`Discount Programs`}
                  banner={appData.banner}
                  component={DiscountProgramsWebViewComponent} />
                <WebViewRoute exact path={['/view/discount-programs/:tribeName']}
                  title={`Discount Programs`}
                  banner={appData.banner}
                  component={DiscountProgramsWebViewComponent} />
                {appData.isBusinessBanner && <PrivateRoute exact path={['/tax-exemption', '/tax-exemption.html']}
                  title={`Tax Exemption`}
                  banner={appData.banner}
                  component={TaxExemptionComponent} />}
                <PrivateRoute exact path={['/account-security', '/account-security.html']}
                  title={`Account Security`}
                  banner={appData.banner}
                  component={AccountSecurityComponent} />
                <PrivateRoute exact path={['/refer-program', '/refer-program.html']}
                  title={`Refer & earn`}
                  banner={appData.banner}
                  component={ReferProgramComponent} />
              </Switch>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}


export default App;

